import { Button, Col, Form, Image, Input, InputNumber, Modal, Row, Select, Switch } from 'antd';
import React, { useState } from 'react';
import { useEffect } from 'react';
import { useCountries } from '../../Countrys/CountryStore';
import { useColors } from '../../Colors/ColorStore';
import { useManufacturer } from '../../Manufacturers/ManufacturerStore';
import MediaManager from '../../../Media/MediaManager';
import { MAIN_URL } from '../../../../Constants';
import { useVariations } from './VarStore';
import { DeleteOutlined } from '@ant-design/icons';

function Add({ vr }) {
    let { countries, getCountries } = useCountries()
    let { colors, getColors } = useColors()
    let { manufacturers, getManufacturer } = useManufacturer()
    let [img, setImg] = useState('')
    let [modal, setModal] = useState(false)
    let [galery, setGalery] = useState([])
    let [gal_modal, setGal_modal] = useState(false)


    useEffect(() => {
        getCountries()
        getColors()
        getManufacturer()
    }, [])
    let { addVariation } = useVariations()

    let handleAdd = (values) => {
        values.pr_id = vr.id
        values.img = img
        values.galery = JSON.stringify(galery)
        addVariation(values)
    }
    let handleGalDelete = (index) => {
        let newGal = galery.filter((item, i) => i !== index)
        setGalery(newGal)
    }
    const handleGallerySelect = (e) => {
        setGalery([...galery, e])
    }

    return (
        <div>
            <Modal width={'80%'} open={gal_modal} footer={null} onCancel={() => setGal_modal(false)}>
                <MediaManager onSelect={handleGallerySelect} />
            </Modal>
            <Modal open={modal} width={'60%'} footer={null} onCancel={() => setModal(false)}>
                <MediaManager onSelect={(v) => { setImg(v); setModal(false) }} />
            </Modal>
            <Form layout="vertical" onFinish={handleAdd}>
                <fieldset>
                    <legend>Qiymatlar</legend>
                    <Button type="primary" onClick={() => setModal(true)}>Rasmni yuklash</Button>
                    {img && <Image src={MAIN_URL + '/' + img} width={100} height={100} style={{ objectFit: 'cover' }} />}
                    <Row gutter={16}>
                        <Col span={12}>
                            <Form.Item
                                name="price_usd"
                                label="Narxi dollarda"
                                rules={[{ required: true, message: 'Please input price!' }]}
                            >
                                <InputNumber style={{ width: '100%' }} min={0} />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                name="dis_usd"
                                label="Chegirma narxi dollarda"
                            >
                                <InputNumber style={{ width: '100%' }} min={0} />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                name="count"
                                label="Joriy soni"
                                rules={[{ required: true, message: 'Please input count!' }]}
                            >
                                <InputNumber style={{ width: '100%' }} min={0} />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                name="sku"
                                label="Skladdagi raqami maxsus kod"
                                rules={[{ required: true, message: 'Please input SKU!' }]}
                            >
                                <Input />
                            </Form.Item>
                        </Col>
                    </Row>
                </fieldset>
                <fieldset>
                    <legend>Parametrlari</legend>
                    <Row gutter={16}>
                        <Col span={12}>
                            <Form.Item
                                name="country_id"
                                label="Davlat"
                            >
                                <Select placeholder="Select country" options={countries.map(country => ({ label: country.nameuz, value: country.id }))} showSearch optionFilterProp="label" />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                name="manufacturer_id"
                                label="Ishlab chiqaruvchi"
                            >
                                <Select placeholder="Select manufacturer" options={manufacturers.map(manufacturer => ({ label: manufacturer.nameuz, value: manufacturer.id }))} showSearch optionFilterProp="label" />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                name="color_id"
                                label="Rangi"
                            >
                                <Select placeholder="Select color" options={colors.map(color => ({ label: color.nameuz, value: color.id }))} showSearch optionFilterProp="label" />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                name="quality"
                                label="Sifati"
                            >
                                <Select options={[
                                    { label: 'Original', value: '1' },
                                    { label: "Pod-Original", value: '2' },
                                    { label: 'Qalbaki', value: '3' },
                                ]} />
                            </Form.Item>
                        </Col>

                        <Col span={12}>
                            <Form.Item
                                name="parametr"
                                label="Qo'shimcha parametri"
                            >
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                name="b_u"
                                label="Oldin ishlatilganmi?"
                            >
                                <Switch />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                name="gallery"
                                label="Galereya"
                            >
                                <Input disabled suffix={<Button type="primary" onClick={() => setGal_modal(true)}>Fayl yuklash</Button>} />
                            </Form.Item>
                            <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                                {galery.length > 0 && galery.map((item, index) => (
                                    <div style={{ position: 'relative' }} key={index}>
                                        <img src={MAIN_URL + '/' + item} alt="" style={{ width: '100px', height: '100px', objectFit: 'cover', margin: '5px' }} />
                                        <Button icon={<DeleteOutlined />} shape='circle' type='primary' size='small' danger onClick={() => handleGalDelete(index)} style={{ position: 'absolute', top: '0px', right: '0px', border: '1px solid #fff' }} />
                                    </div>
                                ))}
                            </div>
                        </Col>
                    </Row>
                </fieldset>
                <Form.Item>
                    <Button type="primary" htmlType="submit">Save</Button>
                </Form.Item>
            </Form>
        </div>
    );
}

export default Add;